import dayjs from '@/utils/dayjs';

export function getRepeatedLessonTimeRange({ startAt, duration, index, unit, timezone }) {
  const firstStart = dayjs.utc(startAt);
  let start = firstStart;
  if (index) {
    const localStart = firstStart.tz(timezone);
    // Advance the calendar date, then resolve its offset in the selected timezone.
    // Adding weeks in UTC (or to a cached zoned offset) shifts the local hour at DST.
    const date = dayjs.utc(localStart.format('YYYY-MM-DD')).add(index, unit).format('YYYY-MM-DD');
    start = dayjs.tz(`${date} ${localStart.format('HH:mm:ss.SSS')}`, timezone).utc();
  }
  return {
    startAt: start.toISOString(),
    endAt: duration ? start.add(duration, 'minute').toISOString() : undefined,
  };
}
